// extracted by mini-css-extract-plugin
export var deliveryRow = "_tb-a";
export var fixedHeight = "_tb-4";
export var freightLogo = "_tb-9";
export var fullWidth = "_tb-3";
export var priceColumn = "_tb-5";
export var radioSelected = "_tb-7";
export var radioUnselected = "_tb-6";
export var selectedOption = "_tb-2";
export var selectedOptionContainer = "_tb-1";
export var selection = "_tb-0";
export var tallSkeletonText = "_tb-8";